// extracted by mini-css-extract-plugin
export default {"customPageContainer":"UbikarePage_customPageContainer__tX1jz","container":"UbikarePage_container__igJCO"};